import { normalizeUri, min, max } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
function findThumbnailUrl(images, minWidth, minHeight) {
  minHeight = minHeight || 190;
  minWidth = minWidth || 190;
  if (images.length === 1) {
    return images[0].source;
  }
  const bigImages = images.filter(function (image) {
    return image.width > minWidth && image.height > minHeight;
  });
  const smallestImage = min(bigImages, function (image) {
    return image.width + image.height;
  });
  if (smallestImage) {
    return smallestImage.source;
  }
  const biggestImage = max(images, function (image) {
    return image.width + image.height;
  });
  return biggestImage.source;
}
export function toItem(data) {
  return {
    id: data.id,
    folderId: null,
    name: data.name || '',
    kind: ItemKind.File,
    source: 'facebook',
    mediaType: MediaType.Picture,
    fileUrl: normalizeUri(data.source),
    thumbnailUrl: normalizeUri(findThumbnailUrl(data.images)),
    previewUrl: normalizeUri(data.source),
    createdAt: data.created_time,
    tags: [],
    width: data.width,
    height: data.height
  };
}